import './css/index.css';
import 'components/download-button/css/defaults.css';
import 'components/footer';
import 'components/breadcrumbs';
import 'components/contact-info';
import 'components/notification';
import 'components/data-explorer';
import 'components/local-navigation';
import 'components/release-calendar';
import 'components/resources-tileset';
import 'components/email-notification';
import 'components/data-download-table';
import 'components/data-viz-detail-hero';
import 'components/data-viz-landing-hero';
import 'components/text-block-full-width';
import 'components/cta-share-page-release';
import 'components/cta-tables-charts-data';
import 'components/link-grid-with-filters';
import 'components/link-grid-promos';
import 'components/related-charts-and-data';
import 'components/related-content-tileset';
import 'components/recent-releases-carousel';
import 'components/text-with-background-image';
import 'components/text-block-full-width-terms';
import 'components/release-calendar-with-contact';
import 'components/text-block-full-width-accordion';
import 'components/related-content-tileset-with-resources';
import 'components/text-with-background-image-with-contact';
import 'components/group-cards-data';
import 'components/card-content-image';
import 'components/card-promo-boxes';
import 'components/custom-select';
import 'components/info-overlay';
import 'components/navigation-sub-section';
import 'components/suggested-citation';
import 'components/toggle-custom-code';

// import last
import 'components/snippets/callouts';
import 'components/snippets/images';
import 'components/snippets/footnotes';

import DataPeriodicReleaseArchiveFilter from 'components/data-periodic-release-archive-filter';
import Mediator from 'js/mediator';
import Navigation from 'components/navigation';
import createTabs from './create-tableau-tabs';
import createSubSectionScroll from 'js/sub-section-nav-scroll';
import UpdatedDataExplorer from 'components/updated-data-explorer';

Mediator.create( {

    componentClasses: [
        Navigation,
        UpdatedDataExplorer,
        DataPeriodicReleaseArchiveFilter,
        {
            name: 'custom-select',
            module: () => import(
                'components/custom-select'
            )
        },
        {
            name: 'chart-select-2',
            module: () => import(
                'components/chart-select-2'
            )
        },
        {
            name: 'info-overlay',
            module: () => import(
                'components/info-overlay'
            )
        },
        {
            name: 'toggle-custom-code',
            module: () => import(
                'components/toggle-custom-code'
            )
        }
    ],

    init() {

        console.info( 'The Release - Historical Release Page has initiated.' );

    },

    ready() {

        console.info( 'The Release - Historical Release Page is ready.' );

        console.info( 'Components:', this.components );

        createTabs( '.navigation-sub-section' );
        createSubSectionScroll( '.navigation-sub-section' );

    }

} );
